import { asc, eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@listto/powersync";

export function getAttachmentsByTodoQuery(db: PowerSyncDrizzleDB, todoId: string) {
  return db
    .select()
    .from(attachment)
    .where(eq(attachment.todo_id, todoId))
    .orderBy(asc(attachment.created_at));
}
